import dayjs from 'dayjs';
import 'dayjs/locale/it';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.locale('it');

/**
 * Formatta una data. Se `localize` è true converte da UTC a orario locale.
 */
export function formatTime(data: string | Date, format = 'ddd DD/MM/YYYY HH:mm', localize = false): string {
    const value = dayjs(data);
    return (localize ? value.utc(true).local() : value).format(format);
}

export default dayjs;
